/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Hero_SubtitleInputs */

const en_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Take your reading with you and listen as you go`)
};

const es_pricing_hero_subtitle = /** @type {(inputs: Pricing_Hero_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lleva tus lecturas contigo y escúchalas donde vayas`)
};

/**
* | output |
* | --- |
* | "Take your reading with you and listen as you go" |
*
* @param {Pricing_Hero_SubtitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_hero_subtitle = /** @type {((inputs?: Pricing_Hero_SubtitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Hero_SubtitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pricing_hero_subtitle(inputs)
	return en_pricing_hero_subtitle(inputs)
});